/**
 * Cache-buster for files in /public/images.
 * Bump this whenever you replace any image at the same path so existing
 * visitors don't keep seeing the old one out of their browser cache.
 */
export const IMAGES_VERSION = '4';

export function img(path: string): string {
  if (!path.startsWith('/')) return path;
  const sep = path.includes('?') ? '&' : '?';
  return `${path}${sep}v=${IMAGES_VERSION}`;
}
